export default "__VITE_ASSET__DH9H1h0I__"